import { createContext } from 'react';

export const PriceContext = createContext<any>(null);
